import { get } from 'aws-amplify/api';

const cache = new Map();
const TTL = 15 * 60 * 1000;
export function cachedHistory(params) {
  const key = JSON.stringify(params), entry = cache.get(key);
  if (entry && entry.expires > Date.now()) return entry.data;
  cache.delete(key); return null;
}
export function requestHistory(params) {
  const operation = get({ apiName: 'readRaceCsvdev', path: '/getPaddockHistory', options: { queryParams: params } });
  const response = operation.response.then(async ({ body }) => {
    const data = await body.json();
    if (data.race_id !== params.race_id || data.schema_version !== 1 || !/^[a-f0-9]{16}$/.test(data.revision || '')) throw new Error('過去診断のレースが一致しません');
    if (params.mode === 'summary' && !Array.isArray(data.horses)) throw new Error('過去診断サマリーが不正です');
    if (params.mode === 'detail' && (data.horse_no !== params.horse_no || data.revision !== params.revision || data.page !== Number(params.page) || !Array.isArray(data.runs))) throw new Error('過去診断の馬・版・ページが一致しません');
    cache.set(JSON.stringify(params), { data, expires: Date.now() + TTL });
    while (cache.size > 100) cache.delete(cache.keys().next().value);
    return data;
  });
  return { response, cancel: () => operation.cancel() };
}
export function clearHistoryCache() { cache.clear(); }
